import * as actionTypes from '../../snackBarActionTypes';
import { AppThunk } from '@greenkub-fronts/shared/interface';

export const addErrorMessage =
  (error: any): AppThunk =>
  (dispatch, getState) => {
    const msgId = getState().snackbar.currentMessageId + 1;
    let messages = getState().snackbar.messages;

    if (error && typeof error === 'string') {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: 'negative',
          content: error,
        },
      ];
    }

    if (error && error.message) {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: 'negative',
          content: error.message,
        },
      ];
    }

    if (error && error.data?.message) {
      messages = [
        ...messages,
        {
          id: msgId,
          severity: 'negative',
          content: error.data.message,
        },
      ];
    }

    dispatch({
      type: actionTypes.ADD_SNACK_MESSAGE,
      payload: {
        currentMessageId: msgId,
        messages,
      },
    });
  };
